import $ from 'jquery';

$(function() {
	
	$('.wp-block-hoyry-itsfinland-event-list').each(function() {
		
		var $block = $(this);
		
		var $categoryWrapper = $block.find('.filter.category');
		var $category = $categoryWrapper.find('select');
		
		var $searchWrapper = $block.find('.filter.search');
		var $search = $searchWrapper.find('input');
		var $searchIcon = $searchWrapper.find('.icon');
		
		var $futureList = $block.find('.future-list');
		var $futureLoadMore = $block.find('.future-load-more');
		var $futureLoadMoreButton = $futureLoadMore.find('button');
		var $noFutureItemsFound = $block.find('.no-future-items-found');
		var futurePage = parseInt( $futureList.data('page') );
		
		var $pastList = $block.find('.past-list');
		var $pastLoadMore = $block.find('.past-load-more');
		var $pastLoadMoreButton = $pastLoadMore.find('button');
		var $noPastItemsFound = $block.find('.no-past-items-found');
		var pastPage = parseInt( $pastList.data('page') );
		
		var maxPages = parseInt( $pastList.data('max-pages') );
		
		// Category
		$category.on('change', function() {
			$categoryWrapper.addClass('loading');
			futurePage = 1;
			pastPage = 1;
			hoyry_itsfinland_event_list_block_update_url_parameter('category', $(this).val());
			hoyry_itsfinland_event_list_block_get_future_list();
			hoyry_itsfinland_event_list_block_get_past_list();
		});
		
		// Search
		$search.on('keypress',function(e) {
			var keycode = (e.keyCode ? e.keyCode : e.which );
			if( keycode == 13 ) {
				$searchWrapper.addClass('loading');
				futurePage = 1;
				pastPage = 1;
				hoyry_itsfinland_event_list_block_update_url_parameter('search', $(this).val());
				hoyry_itsfinland_event_list_block_get_future_list();
				hoyry_itsfinland_event_list_block_get_past_list();
			}
		});
		$searchIcon.on('click',function() {
			$searchWrapper.addClass('loading');
			futurePage = 1;
			pastPage = 1;
			hoyry_itsfinland_event_list_block_update_url_parameter('search', $search.val());
			hoyry_itsfinland_event_list_block_get_future_list();
			hoyry_itsfinland_event_list_block_get_past_list();
		});
		
		// Load more
		$futureLoadMoreButton.on('click', function() {
			$futureLoadMore.addClass('loading');
			futurePage++;
			hoyry_itsfinland_event_list_block_get_future_list();
		});
		$pastLoadMoreButton.on('click', function() {
			$pastLoadMore.addClass('loading');
			pastPage++;
			hoyry_itsfinland_event_list_block_get_past_list();
		});
		
		// Get list
		var hoyry_itsfinland_event_list_block_get_future_list = function() {
			
			hoyry_itsfinland_event_list_block_update_url_parameter('future_pages', futurePage);
			
			$.ajax({
				
				dataType: 'json',
				type: 'GET',
				url: hoyry_itsfinland_event_list_block_rest_url[0] + 'get_future_list',
				data: {
					lang: $('html').attr('lang').substring(0, 2),
					attributes: $futureList.data('attributes'),
					page: futurePage,
					category: $category.val(),
					search: $search.val(),
				}
				
			}).done( function( objData, textStatus, jqXHR ) {
					
				var status = objData.status;
				var data = objData.data;
				var error_message = objData.error_message;
				var debug = objData.debug;
				
				if( status == 'success' ) {
					
					if( futurePage == 1 ) $futureList.html(data['html']);
					else $futureList.append(data['html']);
					
					maxPages = parseInt( data['max_num_pages'] );
					if( futurePage >= maxPages ) $futureLoadMore.hide();
					else $futureLoadMore.show();
					
					if( parseInt( data['found_posts'] ) === 0 ) $noFutureItemsFound.show();
					else $noFutureItemsFound.hide();
					
					$categoryWrapper.removeClass('loading');
					$searchWrapper.removeClass('loading');
					$futureLoadMore.removeClass('loading');
					
				}
				else {
					console.log( error_message );
				}
				
				if( debug ) {
					console.log( debug );
				}
				
			}).fail( function( jqXHR, textStatus, errorThrown ) {
				console.log(errorThrown);
				console.log(MLHttpRequest);
			});
			
		}
		var hoyry_itsfinland_event_list_block_get_past_list = function() {
			
			hoyry_itsfinland_event_list_block_update_url_parameter('past_pages', pastPage);
			
			$.ajax({
				
				dataType: 'json',
				type: 'GET',
				url: hoyry_itsfinland_event_list_block_rest_url[0] + 'get_past_list',
				data: {
					lang: $('html').attr('lang').substring(0, 2),
					attributes: $pastList.data('attributes'),
					page: pastPage,
					category: $category.val(),
					search: $search.val(),
				}
				
			}).done( function( objData, textStatus, jqXHR ) {
					
				var status = objData.status;
				var data = objData.data;
				var error_message = objData.error_message;
				var debug = objData.debug;
				
				if( status == 'success' ) {
					
					if( pastPage == 1 ) $pastList.html(data['html']);
					else $pastList.append(data['html']);
					
					maxPages = parseInt( data['max_num_pages'] );
					if( pastPage >= maxPages ) $pastLoadMore.hide();
					else $pastLoadMore.show();
					
					if( parseInt( data['found_posts'] ) === 0 ) $noPastItemsFound.show();
					else $noPastItemsFound.hide();
					
					$categoryWrapper.removeClass('loading');
					$searchWrapper.removeClass('loading');
					$pastLoadMore.removeClass('loading');
					
				}
				else {
					console.log( error_message );
				}
				
				if( debug ) {
					console.log( debug );
				}
				
			}).fail( function( jqXHR, textStatus, errorThrown ) {
				console.log(errorThrown);
				console.log(MLHttpRequest);
			});
			
		}
		
	});
	
});

// Update url parameter
var hoyry_itsfinland_event_list_block_update_url_parameter = function (key, value) {
    var url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.pushState({}, '', url);
};